import { render } from "./HeaderPrincipal.vue?vue&type=template&id=86c3f1aa&scoped=true"
import script from "./HeaderPrincipal.vue?vue&type=script&lang=js"
export * from "./HeaderPrincipal.vue?vue&type=script&lang=js"

import "./HeaderPrincipal.vue?vue&type=style&index=0&id=86c3f1aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c3f1aa"]])

export default __exports__